import React from "react";

import "../../../scss/loading.scss";

function Ripple() {
  return (
    <div className="theme-card w-100 py-5 d-flex justify-content-center">
      <div className="lds-ripple">
        <div></div>
        <div></div>
      </div>
    </div>
  );
}

export default Ripple;
